import api from '@/api'

const state = {
  hub: [],
  hubDetail: {}
}
const actions = {
  getHub({ commit }, { partnerId, params }) {
    return new Promise((resolve, reject) => {
      api.hub.hubList(partnerId, params).then(
        response => {
          commit('setHub', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createHub({ _ }, { partnerId, payloads }) {
    return new Promise((resolve, reject) => {
      api.hub.createHub(partnerId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getHubDetail({ commit }, { partnerId, hubId }) {
    return new Promise((resolve, reject) => {
      api.hub.hubDetail(partnerId, hubId).then(
        response => {
          commit('setHubDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteHub({ _ }, { partnerId, hubId }) {
    return new Promise((resolve, reject) => {
      api.hub.deleteHub(partnerId, hubId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setHub(state, value) {
    state.hub = value
  },
  setHubDetail(state, value) {
    state.hubDetail = value
  }
}
const getters = {
  hub: state => state.hub,
  hubDetail: state => state.hubDetail
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
